var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.className},[_c('base-button',_vm._b({class:[( _obj = {}, _obj[_vm.activeClassName] = _vm.selected, _obj )],attrs:{"variant":"link","disabled":_vm.isDisabled},on:{"click":_vm.onClick}},'base-button',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }